export default "__VITE_ASSET__6qPCKrsu__"